import React from 'react';
import { FadeIn } from './ui/FadeIn';
const costs = [{
  bad: 'Entrenás sin progresión',
  good: 'Semanas de esfuerzo sin mejora'
}, {
  bad: 'Subidas sin estrategia',
  good: 'Llegás solo a la cima cada sábado'
}, {
  bad: 'Nutrición improvisada',
  good: 'Rendimiento inconsistente y plata perdida'
}, {
  bad: 'Posición sin ajuste',
  good: 'Dolor evitable que se convierte en lesión'
}, {
  bad: 'Sin registro de progreso',
  good: 'No sabés si mejorás o solo te cansás'
}, {
  bad: 'Sin preparación pre-salida',
  good: 'Errores que arruinan la salida antes de empezar'
}];
export function CostOfNotHavingItSection() {
  return <section className="py-12 md:py-16 px-4 bg-slate-950" aria-labelledby="cost-heading" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <FadeIn className="text-center mb-8" data-id="element-92">
          <h2 id="cost-heading" className="text-3xl md:text-4xl font-serif font-bold text-white italic tracking-wide" data-id="element-93">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-94">
          <div className="bg-slate-900 rounded-2xl border border-slate-700 overflow-hidden shadow-xl" data-id="element-95">
            <table className="w-full" role="table" aria-label="Costo de no tener el sistema" data-id="element-96">
              <thead data-id="element-97">
                <tr className="bg-slate-950 border-b border-slate-700" data-id="element-98">
                  <th scope="col" className="p-5 text-center text-slate-300 font-bold text-base md:text-lg" data-id="element-99">
                    Sin PROTORRENDA 4-12
                  </th>
                  <th scope="col" className="p-5 text-center text-red-500 font-bold text-base md:text-lg border-l border-slate-700" data-id="element-100">
                    Costo real
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-800" data-id="element-101">
                {costs.map((row, i) => <tr key={i} data-id="element-102">
                    <td className="p-5 text-center text-slate-400 text-sm md:text-base" data-id="element-103">
                      {row.bad}
                    </td>
                    <td className="p-5 text-center text-white font-bold text-sm md:text-base border-l border-slate-800" data-id="element-104">
                      {row.good}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </FadeIn>
      </div>
    </section>;
}